module.exports = __webpack_public_path__ + "static/media/ms200blk.899c13d3.png";